import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auth-re-password-three',
  templateUrl: './auth-re-password-three.component.html',
  styleUrls: ['./auth-re-password-three.component.css']
})

/**
 * Auth RePassword-three Component
 */
export class AuthRePasswordThreeComponent implements OnInit {

  year = new Date().getFullYear()
  constructor() { }

  ngOnInit(): void {
  }

}
